



































import {Component, Prop, Vue} from 'vue-property-decorator';
import FileSelectionStep from '@/components/Importer/FileSelectionStep.vue';
import ImportSelectionStep from '@/components/Importer/ImportSelectionStep.vue';

@Component({
  components: {
    FileSelectionStep,
    ImportSelectionStep,
  }
})
export default class PassengerImportsPage extends Vue {

  stepperStep: number = 1; 
  
  get disableBackButton() {
    return this.stepperStep === 1;
  }

  get disableForwardButton() {
    return this.stepperStep === 2;
  }

  nextStep() {
    const newStep = this.stepperStep + 1;
    if (newStep <= 2) {
      this.stepperStep = newStep;
    }
  }

  backStep() {
    const newStep = this.stepperStep - 1;
    if (newStep >= 1) {
      this.stepperStep = newStep;
    }
  }

}
